import { ar, en } from "languages";
import { useSelector } from "react-redux";

/* custom react hook to return current language object */

export default function useLanguage() {
  const language = useSelector((state) => state.app.language);  // call language from app store

  return language === "ar" ? ar : en; // return language object base on current language
}
